export const ALL_PERMISSIONS = [
  "dashboard.view",
  "users.view",
  "users.manage",
  "trips.view",
  "trips.manage",
  "purchases.view",
  "purchases.manage",
  "packages.view",
  "packages.manage",
  "deliveries.view",
  "deliveries.manage",
  "support.view",
  "support.manage",
  "rentals.view",
  "rentals.manage",
  "leave.view",
  "leave.manage",
  "finance.view",
  "finance.manage",
  "audit.view",
  "admins.manage",
] as const;

export type AdminPermission = (typeof ALL_PERMISSIONS)[number];
export type AdminRole = "ADMIN" | "SUPER_ADMIN";
export type AdminStatus = "ACTIVE" | "SUSPENDED" | "REVOKED";

export type AdminAccess = {
  user_id: string;
  role: AdminRole;
  permissions: AdminPermission[];
  status: AdminStatus;
  version: number;
};

export const PERMISSION_GROUPS: Array<{
  label: string;
  description: string;
  permissions: AdminPermission[];
}> = [
  { label: "Dashboard", description: "ภาพรวมและคิวงาน", permissions: ["dashboard.view"] },
  { label: "Users", description: "ดู แก้ไขโปรไฟล์ หรือระงับบัญชีผู้ใช้", permissions: ["users.view", "users.manage"] },
  { label: "Trips", description: "ดูและเปลี่ยนสถานะทริป", permissions: ["trips.view", "trips.manage"] },
  { label: "Buy for me", description: "คำขอซื้อและการคัดกรอง", permissions: ["purchases.view", "purchases.manage"] },
  { label: "Packages", description: "พัสดุคาดหมายและคลังรับเข้า", permissions: ["packages.view", "packages.manage"] },
  { label: "Deliveries", description: "คิวจัดส่งและหลักฐานส่งมอบ", permissions: ["deliveries.view", "deliveries.manage"] },
  { label: "Support", description: "เคส SLA และการมอบหมาย", permissions: ["support.view", "support.manage"] },
  { label: "Rentals", description: "เช่า ส่ง คืน และตรวจสภาพ", permissions: ["rentals.view", "rentals.manage"] },
  { label: "Leave", description: "รับคืน เกรด และ second life", permissions: ["leave.view", "leave.manage"] },
  { label: "Finance", description: "ยอดชำระจริงและ Stripe refund", permissions: ["finance.view", "finance.manage"] },
  { label: "Audit", description: "ประวัติการทำงานของผู้ดูแล", permissions: ["audit.view"] },
];

export function hasPermission(access: AdminAccess | null, permission: AdminPermission) {
  return Boolean(access && (access.role === "SUPER_ADMIN" || access.permissions.includes(permission)));
}

export function labelPermission(permission: AdminPermission) {
  const [module, action] = permission.split(".");
  return `${module} · ${action}`;
}
